import * as Yup from "yup";

export const productValidation = Yup.object().shape({
  name: Yup.string()
    .required("وارد کردن نام الزامی است")
    .min(3, "نام حد اقل باید 3 حرفی باشد."),
  basePrice: Yup.string().required("وارد کردن قیمت پایه الزامی است"),
});
